import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';

export default function RankingEvalConversationSetScreen() {
    const { SpacesScreen } = useModule(rankingEvalModuleQuery);
    return <SpacesScreen />;
}
